export default __webpack_public_path__ + "static/media/spltll.26d93c70.png";